import { ArrowRightIcon } from '@repo/icons';
import type { TestId } from '@repo/test-id';
import { type ReactNode } from 'react';
import { Button } from '@repo/ui';

interface Props {
  label: string;
  testId: TestId;
  onClick: () => void;
  disabled?: boolean;
  pending?: boolean;
  topNote?: ReactNode;
  bottomNote?: ReactNode;
}

export default function PageBottomButton({ label, testId, onClick, disabled, pending, topNote, bottomNote }: Props) {
  return (
    <div className="bg-primary md:bg-soft-orange z-floating sticky right-0 bottom-0 left-0 px-4 pt-3 pb-5">
      {topNote && <div className="text-body pb-2 text-center text-sm leading-5 font-normal">{topNote}</div>}
      <Button
        color="brand"
        size="lg"
        className="w-full"
        rightIcon={ArrowRightIcon}
        testId={testId}
        label={label}
        onClick={onClick}
        disabled={disabled}
        pending={pending}
      />
      {bottomNote && <div className="text-body pt-2 text-center text-sm leading-5 font-normal">{bottomNote}</div>}
    </div>
  );
}
